<template>
    <v-container>
        <v-breadcrumbs :items="breadcrumbs" link>
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
        <v-card dark elevation="1">
            <v-card-title>
                สร้างผู้ใช้งานใหม่
            </v-card-title>
            <v-card-subtitle>
                โปรดตรวจสอบความถูกต้องของข้อมูลก่อนยืนยัน
            </v-card-subtitle>
             <v-divider></v-divider>
             <v-card-text>
                <user-form ref="userForm" />
                <v-divider></v-divider>
                    <v-btn class="mt-3" @click="$refs.userForm.submit()">
                        สร้างผู้ใช้งาน
                    </v-btn>
             </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import UserForm from '../../components/UserForm.vue';

export default {
    data: () => ({
        breadcrumbs: [
        {
          text: 'หน้าหลัก',
          disabled: false,
          href: '/'
        },
        {
            text: 'ผู้ใช้งาน',
            disabled: false,
            href: '/users'
        },
        {
          text: 'สร้างผู้ใช้งานใหม่',
          disabled: true,
          href: '/users/create'
        }
      ]
    }),
    methods: {
    },
    watch: {
        ['form.role'](value){
            if(value != '2'){
                this.form.permission = [];
            }
        },
        errorMessage(){
            if(this.errorMessage != ''){
                this.$refs.alertError.show();
            }
        }
            
    },
    components: {
        UserForm
    }
};
</script>